export default "__VITE_ASSET__57cb8c7b__"